import { ProgressReportRowDto } from './progress-report-row.dto';

/**
 * One row of the Raporty table, already worded: the dashes, produkt końcowy and tak/nie are
 * decided here once, so the table and the exported file say the same thing.
 */
export interface ReportRowVm {
  lineId: number;
  reportId: number;
  /** "2026-10-23 14:12", local time. */
  reportedAtLabel: string;
  /** The reporter's display name, "—" for a report from before 0059. */
  reporterLabel: string;
  orderId: number;
  orderNumber: string;
  orderName: string;
  itemName: string;
  /** The parent's name, or produkt końcowy for a root (the overseer's words). */
  parentLabel: string;
  /** The root's name — the root's own on a root row, so one machine's rows all read the same. */
  rootName: string;
  /** The stage's name, "—" when untagged. */
  stageLabel: string;
  amount: number;
  unit: string;
  completesLabel: 'tak' | 'nie';
}

export namespace ReportRowVm {
  export function mapModelToViewModel(row: ProgressReportRowDto): ReportRowVm {
    return {
      lineId: row.lineId,
      reportId: row.reportId,
      reportedAtLabel: formatDateTime(new Date(row.reportedAt)),
      reporterLabel: row.reportedByName ?? '—',
      orderId: row.orderId,
      orderNumber: row.orderNumber,
      orderName: row.orderName,
      itemName: row.itemName,
      parentLabel: row.parentName ?? 'produkt końcowy',
      rootName: row.rootName,
      stageLabel: row.operationName ?? '—',
      amount: row.amount,
      unit: row.unit,
      completesLabel: row.completesItem ? 'tak' : 'nie'
    };
  }
}

/** "2026-10-23 14:12" in the browser's time zone — the plant's clock, on screen and in the file. */
export function formatDateTime(date: Date): string {
  return `${formatDay(date)} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
}

/** "2026-10-23", local. */
export function formatDay(date: Date): string {
  return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
}

export function pad(value: number): string {
  return String(value).padStart(2, '0');
}
